import { render } from "./Destination.vue?vue&type=template&id=73c368e5&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"

import "./Destination.vue?vue&type=style&index=0&id=73c368e5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c368e5"]])

export default __exports__